import { Params, ParamMap } from '@angular/router';

export const FILLED_OUT_FORM_STATUS_IDS_KEY = 'fs';

interface FilledOutFormStatusIdsArg {
	filledOutFormStatusIds?: number[];
}

export const toFilledOutFormStatusIdsParams = (
	args: FilledOutFormStatusIdsArg
): Params => {
	return {
		[FILLED_OUT_FORM_STATUS_IDS_KEY]: args.filledOutFormStatusIds
			? args.filledOutFormStatusIds
			: undefined,
	};
};

export const toFilledOutFormStatusIdsListArgs = (
	paramMap: ParamMap
): { filledOutFormStatusIds: number[] } =>
	paramMap.has(FILLED_OUT_FORM_STATUS_IDS_KEY)
		? {
				filledOutFormStatusIds: paramMap
					.getAll(FILLED_OUT_FORM_STATUS_IDS_KEY)
					.map((status) => +status),
		  }
		: undefined;
